import {
	Card,
	CardContent,
	CardHeader,
	type CardProps,
	type CardContentProps,
	type CardHeaderProps,
	TypographyProps,
	Typography,
} from '@mui/material'
import { type ComponentType, type ComponentProps, type ReactNode } from 'react'
import { alpha, styled } from '@mui/material/styles'

import { STACKED_HEADER_BREAKPOINT } from '../../utils'

export const ActiveCard: ComponentType<CardProps> = styled( Card )( ( { theme } ) => ( {
	borderRadius: theme.shape.borderRadius,
	boxShadow: 'none',
	border: `1px solid ${theme.palette.primary.main}`,
	backgroundColor: alpha( theme.palette.primary.main, 0.05 ),
	padding: theme.spacing( 1, 2, 2, 2 ),
	containerType: 'inline-size',
} ) )

export const ActiveCardHeader: ComponentType<CardHeaderProps> = styled( CardHeader )( ( { theme } ) => ( {
	[ `@container (max-width: ${STACKED_HEADER_BREAKPOINT}px)` ]: {
		'alignItems': 'flex-start',
		'flexDirection': 'column',

		'& .MuiCardHeader-avatar': {
			marginBottom: theme.spacing( 1 ),
			marginRight: 0,
		},
	},
} ) )

export const ActiveCardContent: ComponentType<CardContentProps> = styled( CardContent )( () => ( {
	paddingTop: 0,
} ) )

export const ActiveCardContentInnerWrapper: ComponentType<{
	children: ReactNode,
}> = styled( 'div' )( ( { theme } ) => ( {
	display: 'flex',
	flex: 1,
	flexDirection: 'column',
	alignItems: 'flex-start',
	justifyContent: 'space-between',
	gap: theme.spacing( 1 ),
	minHeight: theme.spacing( 17 ),
} ) )

export const ActiveCardDetails: ComponentType<{ children: ReactNode }> = styled( 'ul' )( () => ( {
	margin: 0,
	padding: 0,
	listStyle: 'none',
} ) )

export const ActiveCardTitle: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	fontWeight: theme.typography.fontWeightSemiBold,
} ) )

export const ActiveCardName: ComponentType<TypographyProps> = styled( Typography )( ( { theme } ) => ( {
	color: theme.palette.text.primary,
	fontWeight: theme.typography.fontWeightRegular,
	fontSize: '14px',
} ) )

export const IntegrationImage: ComponentType<ComponentProps<'img'>> = styled( 'img' )( ( { theme } ) => ( {
	width: 100,
	height: 60,
	padding: theme.spacing( 2, 2, 2, 0 ),
	objectFit: 'contain',
	borderRadius: theme.shape.borderRadius,

	[ `@container (max-width: ${STACKED_HEADER_BREAKPOINT}px)` ]: {
		padding: theme.spacing( 2, 0, 0, 0 ),
	},
} ) )
